
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { GET_CUSTOMER, UPDATE_CUSTOMER } from '@/queries/Customer';
import CustomerForm from '@/components/Customer/CustomerForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_updateCustomer } from '@/queries/__generated__/updateCustomer';
import { GQL_customer_customer } from '@/queries/__generated__/customer';
import { GQL_CustomerUpdate } from '@/queries/global';

@Component({
  components: {
    CustomerForm,
  },
})
export default class CustomerEdit extends Vue {
  @Prop([ Number, String ]) public id!: number | string;
  public GET_CUSTOMER = GET_CUSTOMER;
  public UPDATE_CUSTOMER = UPDATE_CUSTOMER;

  @Emit()
  public customerUpdated(store: InMemoryCache, query: { data: GQL_updateCustomer }) {
    return query.data.updateCustomer && query.data.updateCustomer.customer;
  }

  private convertToForm(data: GQL_customer_customer | null): GQL_CustomerUpdate | null {
    if (!data) return null;
    return {
      ...data,
      deliveryLocations: data.deliveryLocations.map(deliveryLocation => {
        return {
          ...deliveryLocation,
          countryCode: deliveryLocation.country.code,
        };
      }),
    };
  }
}
